import styled from 'styled-components'
import { device } from './breakpoints'

const Link = styled.a`
  font-size: 1.2rem;
  font-family: var(--font-plex);
  color: var(--text-color);
  text-decoration: underline;
`

const LinkIcon = () => (
    <svg width='12px' height='14px' viewBox='0 0 12 14'>
      <g
        stroke='none'
        strokeWidth='1'
        fill='red'
        fillRule='evenodd'
      >
          <g transform='translate(2.812816, -0.000000)'>
            <rect x='2.18718434' y='0' width='7' height='1.5' />
            <rect
              transform='translate(4.419417, 4.819417) rotate(-45.000000) translate(-4.419417, -4.819417) '
              x='-1.08058262'
              y='4.06941738'
              width='11'
              height='1.5'
            />
            <rect x='7.68718434' y='0' width='1.5' height='7' />
          </g>
        </g>
    </svg>
  )

export { Link, LinkIcon }
